document.querySelectorAll( '.p-single-post .b-toc' ).forEach( ( toc ) => {

	// Build each table once, even if this script runs again on the page.
	if ( toc.dataset.tocBuilt ) {

		return;

	}
	toc.dataset.tocBuilt = '1';

	// Tables inside the blog content container are built by the block's own script.
	if ( toc.closest( '.b-blog-post-content-container' ) ) {

		return;

	}

	const singlePost = toc.closest( '.p-single-post' );
	if ( ! singlePost ) {

		return;

	}

	// Blog posts built on the content container: read only the article, not the sidebar cards.
	const blogContent = singlePost.querySelector( '.b-blog-post-content-container__content' );
	const contentSelector = toc.dataset.contentSelector || ( blogContent ? '.b-blog-post-content-container__content' : '.p-single-post__content-inner' );
	const contentWrapper = singlePost.querySelector( contentSelector );

	if ( ! contentWrapper ) {

		return;

	}

	const nesting = parseInt( toc.dataset.nest || '1', 10 );
	let headers = [];
	switch ( nesting ) {

	case 1:
		headers = contentWrapper.querySelectorAll( 'h2, h3, h4' );
		break;
	case 2:
		headers = contentWrapper.querySelectorAll( 'h3, h4' );
		break;
	case 3:
		headers = contentWrapper.querySelectorAll( 'h3' );
		break;
	case 4:
		headers = contentWrapper.querySelectorAll( 'h2' );
		break;
	default:
		headers = contentWrapper.querySelectorAll( 'h2, h3, h4' );

	}

	// Remove any heading that was matched more than once.
	headers = Array.from( new Set( headers ) );

	if ( ! headers.length ) {

		return;

	}

	const listTag = nesting === 1 ? 'ul' : 'ol';
	const list = document.createElement( listTag );
	let lastH3ListItem = null;
	let generatedId = 0;

	headers.forEach( ( header ) => {

		if ( ! header.id ) {

			generatedId += 1;
			header.id = `single-toc-header-${ generatedId }`;

		}

		const item = document.createElement( 'li' );
		const anchor = document.createElement( 'a' );
		anchor.href = `#${ header.id }`;
		anchor.textContent = header.textContent;
		item.appendChild( anchor );

		if ( header.tagName === 'H3' ) {

			lastH3ListItem = item;
			list.appendChild( item );

			if ( nesting === 1 || nesting === 2 ) {

				item.appendChild( document.createElement( 'ul' ) );

			}
			return;

		}

		if ( header.tagName === 'H2' ) {

			list.appendChild( item );

			if ( nesting === 1 ) {

				item.appendChild( document.createElement( 'ul' ) );

			}
			return;

		}

		if ( header.tagName === 'H4' && ( nesting === 1 || nesting === 2 ) && lastH3ListItem ) {

			const nestedList = lastH3ListItem.querySelector( 'ul' );
			if ( nestedList ) {

				nestedList.appendChild( item );

			}

		}

	} );

	toc.appendChild( list );

} );
